import { RequirementType } from "PFTypes";

export const shouldShowDurationWarning = (
  durationType: RequirementType | null,
  durationValue: number | null,
  totalHours: number
): boolean =>
  durationType === RequirementType.TotalHours && durationValue !== null && durationValue > totalHours;
